export const TEST_MESSAGE_BOT_LINK = 'https://t.me/Testmessagetelegiv_bot';
export const TG_DOT_NAME = '@Testmessagetelegiv_bot';

export const ALL_VALUE = 'all';
